<template>
          <!-- contents -->
          <div id="contents">
            <div class="contents_wrap">
              <!-- contents_head -->
              <!-- breadcrumbs -->
              <skp-breadcrumbs @page-title="val => pageTitle = val" />
              <!-- //breadcrumbs -->
              <h2 class="pg_title">{{ pageTitle }}</h2>
              <!-- //contents_head -->

              <!-- srchTop_wrap -->
              <div class="srchTop_wrap">
                <article class="srch_basic">
                  <div class="srch_grup">
                    <ul class="w50">
                      <li class="tit_150">Subsidiary</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select id="selectRhqCd1" name="selectRhqCd1" v-model="selectRhqCd" @change="changeRhqCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqCd ? (item.code == selectRhqCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select id="selectRhqSubCd1" name="selectRhqSubCd1" v-model="selectRhqSubCd" @change="changeRhqSubCd($event)" class="slt_white w100">
                                <option value="" v-if="isAllUser() ? true : false" >{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-for="(item, index) in rhqSubCdList"
                                        :key="item.code"
                                        :value="item.code"
                                        :selected="selectRhqSubCd ? (item.code == selectRhqSubCd ? true : false) : (index === 0 ? true : false)">{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>

                    <ul class="w100">
                      <li class="tit_150">Category</li>
                      <li data-input-type="select" class="w100-150">
                        <fieldset class="ui_fieldset set_3">
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD1"
                                    v-model="PRD_CATEGORY_CD1"
                                    @change="changeCategory1($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList1.length > 0"
                                        v-for="item in categoryComboList1"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD2"
                                    v-model="PRD_CATEGORY_CD2"
                                    @change="changeCategory2($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList2.length > 0"
                                        v-for="item in categoryComboList2"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                          <div>
                            <select class="slt_white w100p"
                                    id="PRD_CATEGORY_CD3"
                                    v-model="PRD_CATEGORY_CD3"
                                    @change="changeCategory3($event)">
                                <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                <option v-show="categoryComboList3.length > 0"
                                        v-for="item in categoryComboList3"
                                        :key="item.code"
                                        :value="item.code"
                                >{{item.codeName}}</option>
                            </select>
                          </div>
                        </fieldset>
                      </li>
                    </ul>
                    <ul class="w50">
                        <li class="tit_150">
                            Period <em class="txt_mandatory">*</em>
                        </li>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                        <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="from-picker-container" style="margin-top: -1px;"></div>
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                        <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                    </label>
                                    <div id="to-picker-container" style="margin-top: -1px;"></div>
                                </span>
                            </fieldset>
                        </dd>
                    </ul>
                    <ul class="w100">
                        <li class="tit_150">Content</li>
                        <li data-input-type="select" class="w100-150">
                            <!-- 200515수정 S -->
                            <fieldset class="ui_fieldset ui_right">
                                <label class="checkbox-wrap" v-for="item in checkList" :key="item.ID">
                                    <input type="checkbox" :value="item.ID" v-model="checkedVal"><i class="check-icon"></i>
                                    <em>{{item.NM}}</em>
                                </label>
                            </fieldset>
                            <!-- 200515수정 E -->
                        </li>
                    </ul>
                  </div>
                  <div class="srch_grupR_bottom">
                    <span class="btn">
                      <a href="javascript:" class="btn_srch" @click="search(1)">Search</a>
                    </span>
                  </div>
                </article>
              </div>
              <!-- Grid -->
              <!-- Grid -->
              <div class="grid_wrap number-cell">
                    <!-- Count -->
                <!-- <div class="grid_total">
                    Total&nbsp;Count&nbsp;
                    <em>{{ totalCount | numberFormat }}</em>
                </div> -->
                <div class="btn_wrap">
                    <a
                            href="javascript:"
                            class="btn_white"
                            @click="excelDownload()"
                            title
                        >{{ $t('FIELD.GLOBAL.EXCELDOWNLOAD') }}</a>
                </div>
                <!-- Grid -->
                <toast-grid
                    :gridId="gridId"
                    :ref="gridId"
                    :data="gridData"
                    :columns="columns"
                    :options="options"
                    :header="header"
                    :key="gridKey"
                    :pageOptions="pageOptions"
                    :isTotalCount="false"
                    :click="contentClick"
                />
            </div>

            <!-- <div class="paginate">
                <sdl-pagination
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="search"
                    align="center"
                />
             </div> -->
            </div>
          </div>
          <!-- contents -->

</template>

<script>
import Vue                                  from 'vue';
import { mapActions, mapGetters }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import qs                                   from 'query-string';
import axios                                from 'axios';
import moment                               from 'moment';
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';


import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';
import DatePicker                           from '~c/DatePicker';
import ToastGrid                            from '~c/ToastGrid';

import ExcelDownloadPopup                   from '~vb/common/ExcelDownloadPopup';



// java to moment dateformat parser
require('moment-jdateformatparser');

const fetchGridData = params => axios.post(
    `${SDLUtil.API_URL}/basis/admin/statisticsManager/reprocessRatioSearch.skp`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

const ICON_IMG = {
    excel:       { on: '/static/images/ico_f_xls.gif',          off: ''}
};
class CustomImageRenderer {
    constructor(props) {
        const el = document.createElement('img');
        const { imgType } = props.columnInfo.renderer.options;
        let onImg = '', offImg = '';
        // renderer by column type
        switch(imgType) {
            case 'excel'    : onImg = ICON_IMG.excel.on,         offImg = ICON_IMG.excel.off;         break;
            default         : break;
        };
        let isImg = false;
        if(!SDLUtil.isNull(props.value)) {
            if(props.value > 0 ) isImg = true;
        }
        el.src = isImg ? onImg : offImg;
        el.className = 'cur_pointer';
        this.el = el;
    }

    getElement() {
        return this.el;
    }
};

export default {
    name : 'reprocessRatioList',
    props : {

    },
    data() {
        return {
            isProcess: true,

            selectRhqCd: '',
            selectRhqNm: '',
            selectRhqSubCd: '',
            selectRhqSubNm: '',

            rhqCdList: [],
            rhqSubCdList: [],


            PRD_CATEGORY_CD1: '',   // Category 1
            PRD_CATEGORY_CD2: '',   // Category 2
            PRD_CATEGORY_CD3: '',   // Category 3
            categoryComboList1: [], // Category 1 List
            categoryComboList2: [], // Category 2 List
            categoryComboList3: [], // Category 3 List

            FROM_DATE: {},
            TO_DATE: {},

            selectAll: false,

            checkList: [{ID:'SB',NM : 'Service Bulletin'}, {ID:'SM',NM : 'Service Manual'}, {ID:'AT',NM : 'Agent Tip'}, {ID:'RT',NM : 'Repair Tip'}],
            checkedVal:[],

            pageTitle : '',
            perPage: parseInt(localStorage.getItem('listRows') || 10),
            currentPage: 1,
            totalCount : 0,
            gridId : "reprocessRatioGrid",
            gridKey: 0,
            gridData : [],
            header: {
                height: 80,
                complexColumns: [
                    {
                        header: 'On time',
                        name: 'mergeColumn1',
                        childNames: ['ON_TIME_REG', 'ON_TIME_RATE']
                    },
                    {
                        header: 'Out of time',
                        name: 'mergeColumn2',
                        childNames: ['OUT_OF_TIME_REG', 'OUT_OF_TIME_RATE']
                    },
                ]
            },
            columns : [
                {
                    header: "Product Info.",
                    name: "BOARD_NM_CVS",
                    //width: 200,
                    align: "left",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Total",
                    name: "TOTAL",
                    width: 100,
                    align: "right",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Registration",
                    name: "ON_TIME_REG",
                    align: "right",
                    width: 100,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Ratio",
                    name: "ON_TIME_RATE",
                    align: "right",
                    width: 100,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Registration",
                    name: "OUT_OF_TIME_REG",
                    width: 100,
                    align: "right",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Ratio",
                    name: "OUT_OF_TIME_RATE",
                    width: 100,
                    align: "right",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "On time(deleted)",
                    name: "DEL_ON_TIME_REG",
                    width: 120,
                    align: "right",
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Out of time(deleted)",
                    name: "DEL_OUT_OF_TIME_REG",
                    align: "right",
                    width: 150,
                    sortable: false,
                    resizable: true,
                },
                {
                    header: "Raw Data",
                    name: "RAW_DATA",
                    align: "center",
                    width: 80,
                    renderer: { type: CustomImageRenderer, options: { imgType : 'excel' } },
                    sortable: false,
                    resizable: false,
                },
                {
                    header: "RHQCD",
                    name: "RHQCD",
                    hidden: true,
                },
                {
                    header: "SUBSIDIARYCD",
                    name: "SUBSIDIARYCD",
                    hidden: true,
                },
                {
                    header: "BOARD_NM",
                    name: "BOARD_NM",
                    hidden: true,
                },
                {
                    header: "START_DATE",
                    name: "START_DATE",
                    hidden: true,
                },
                {
                    header: "END_DATE",
                    name: "END_DATE",
                    hidden: true,
                },
                {
                    header: "PRD_CATEGORY_CD1",
                    name: "PRD_CATEGORY_CD1",
                    hidden: true,
                },
                {
                    header: "PRD_CATEGORY_CD2",
                    name: "PRD_CATEGORY_CD2",
                    hidden: true,
                },
                {
                    header: "PRD_CATEGORY_CD3",
                    name: "PRD_CATEGORY_CD3",
                    hidden: true,
                },

            ],
            options : {
                scrollX: true,
                scrollY: false,
                header: { height: 45 },
                rowHeight: 45,
            },
            pageOptions : {},
        }
    },
    computed: {
        ...mapGetters({
            userRoles:  'getRoles',
            userCorpCd: 'getCorpCd',
            params:     'getParams',
            locale:     'getLocale',
            menus:      'getMenus',
            loginNo:    'getLoginNo',
            loginRhq:   'getLoginRhq'
        }),
        getDateformat() {
            return localStorage.getItem('mDateFormat');
        },
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        getLoginRHQCd() {
            return this.loginRhq || '';
        },
        getLoginCompanyCd() {
            return this.userCorpCd || '';
        },
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || '';
        },

    },
    components: {
        'skp-breadcrumbs' : SKPBreadcrumbs,
        'toast-grid' : ToastGrid
    },
    methods: {
        categoryClear(){
            this.setCategory1();
            this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
            this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
        },
        async getCodeComboList(categoryVal, categoryCode) {
            let corpCd = this.selectRhqSubCd == "" ? this.getUserCorpCd : this.selectRhqSubCd;
            const codeResp = await api.getComboList(categoryVal, categoryCode, corpCd);
            return codeResp;
        },
        async getCodeComboList1(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        getComboBoxVal(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).value : "";
        },
        getComboBoxName(comboId) {
            return document.getElementById(comboId) ? document.getElementById(comboId).name : "";
        },
        // 지역 코드 변경 이벤트
        changeRhqCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.rhqSubCdList = [], this.selectRhqSubCd = '';
            } else {
                this.getCodeComboList1(comboValue, "SUB_AUTH_ACCESS_CD").then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = '';
                });
            }
            this.categoryClear();
        },
        // 법인 코드 변경 이벤트
        changeRhqSubCd(e) {
            let comboValue = this.getComboBoxVal(e.target.id);
            if(comboValue == "") {
                this.selectRhqSubCd = '';
                this.selectRhqSubNm = '';
            } else {
                this.selectRhqSubCd = this.getComboBoxVal(e.target.id);
                this.selectRhqSubNm = this.getComboBoxName(e.target.id);
            }
            this.categoryClear();
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.PRD_CATEGORY_CD1 = "";
                this.categoryComboList1 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1() {
            if(this.PRD_CATEGORY_CD1 == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(this.PRD_CATEGORY_CD1, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2 = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2() {
            if(this.PRD_CATEGORY_CD2 == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';

            } else {
                this.getCodeComboList(this.PRD_CATEGORY_CD2, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // 세번째 카테고리 변경 이벤트
        async changeCategory3() {
            if(this.PRD_CATEGORY_CD3 == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },



        // 권한체크
        isAllUser(){

            if(this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`) ||
               this.getUserRole.includes(`${constants.GBM_ADMIN}`) ||
               this.getUserRole.includes(`${constants.RHQ_ADMIN}`))
            {
                return true;
            }else{
                return false;
            }

        },

        // 버튼 이벤트
        async search(pageNo) {

            let validContents = this.registVerifyContents();
            let checkedVal = "";
            if(this.checkedVal.length > 0) {
                checkedVal = this.checkedVal.join(',');
            }
            if(validContents) {
                if (!pageNo) pageNo = 1;
                const mFormat = localStorage.getItem('mDateFormat');
                let params = {
                    page             : pageNo,
                    RHQCD            : this.selectRhqCd,
                    RHQSUBCD         : this.selectRhqSubCd,
                    PRD_CATEGORY_CD1 : this.PRD_CATEGORY_CD1,
                    PRD_CATEGORY_CD2 : this.PRD_CATEGORY_CD2,
                    PRD_CATEGORY_CD3 : this.PRD_CATEGORY_CD3,
                    FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                    TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '',
                    CHECKEDVAL          : checkedVal,
                };

                SDLUtil.showLoadingBar(true);
                const response = await fetchGridData(params)
                    .then(res => {
                        let data = res.data;
                        this.totalCount = data.totalCount;
                        this.gridData = data.result;
                        this.gridKey++;

                        this.$nextTick(() => {
                            let idx = 0;
                            this.gridData.forEach(row => {
                                if(row.BOARD_NM_CVS.includes("Total")) {
                                    this.$refs[this.gridId].addRowClassName(idx, 'sub_total');
                                }
                                idx++;
                            });
                        });

                        SDLUtil.showLoadingBar(false);
                    })
                    .catch(err => {
                        SDLUtil.errorAlert(err);
                        SDLUtil.showLoadingBar(false);
                    });
            }
        },
        // 컨텐츠 클릭 이벤트 -> KnowledgeListGrid
        contentClick(e, rowData, grid) {

            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData[e.rowKey];
            let total = row['TOTAL'] || '';
            // 컬럼별 이벤트 실행
            if( colNm === 'RAW_DATA') {
                if(total > 0) {
                    this.excelRowDownload(row);
                }
            }

        },
        excelRowDownload(row) {
            // Total row (BOARD_NM undefined): pass the Content actually checked on the page
            let checkedVal = "";
            if(this.checkedVal.length > 0) {
                checkedVal = this.checkedVal.join(',');
            }
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/reprocessRatioRowDataExcel.skp`,
                            qs.stringify({
                                RHQCD            : (row['RHQCD'] || row['SUBSIDIARYCD']) ? (row['RHQCD'] || '') : this.selectRhqCd,
                                RHQSUBCD         : (row['RHQCD'] || row['SUBSIDIARYCD']) ? (row['SUBSIDIARYCD'] || '') : this.selectRhqSubCd,
                                BOARD_NAME       : row['BOARD_NM'] || '',
                                START_DATE       : row['START_DATE'] || '',
                                END_DATE         : row['END_DATE'] || '',
                                PRD_CATEGORY_CD1 : row['PRD_CATEGORY_CD1'] || '',
                                PRD_CATEGORY_CD2 : row['PRD_CATEGORY_CD2'] || '',
                                PRD_CATEGORY_CD3 : row['PRD_CATEGORY_CD3'] || '',
                                CONTENT_TYPES    : checkedVal
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        excelDownload() {
            SDLUtil.confirm({
                msg: 'Do you want to download the Excel file?<br>Data will be download up to 5000 lines.',
                onOkEvt: () => {
                    let checkedVal = "";
                    if(this.checkedVal.length > 0) {
                        checkedVal = this.checkedVal.join(',');
                    }
                    SDLUtil.showLoadingBar(true);
                    const mFormat = localStorage.getItem('mDateFormat');
                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/admin/statisticsManager/reprocessRatioExcel.skp`,
                            qs.stringify({
                                RHQCD            : this.selectRhqCd,
                                RHQSUBCD         : this.selectRhqSubCd,
                                PRD_CATEGORY_CD1 : this.PRD_CATEGORY_CD1,
                                PRD_CATEGORY_CD2 : this.PRD_CATEGORY_CD2,
                                PRD_CATEGORY_CD3 : this.PRD_CATEGORY_CD3,
                                FROM_DATE        : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : '',
                                TO_DATE          : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : '',
                                CHECKEDVAL       : checkedVal
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        registVerifyContents() {
            let validList = [''];
            if(SDLUtil.isNull(this.rangePicker.getStartDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(SDLUtil.isNull(this.rangePicker.getEndDate()))    validList.push((validList.length > 0 ? '<br/>' : '') + '<span class="txt_color1">' + 'Period' + '</span>');
            if(validList.length > 1) {
                SDLUtil.alert({
                    msg: 'The following fields are required to start search.' + '<br/>' + '<span class="txt_color1">' + 'Period' + '</span>',
                    class: 'sm_size'
                });
                return false;
            } else {
                return true;
            }
        },

    },
    created() {
        // 초기 카테고리1 리스트 로드
        this.setCategory1();
    },

    mounted() {

        this.$nextTick(() => {
            this.getCodeComboList1(this.getLoginNo, "RHQ_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqCdList = data;
                    this.selectRhqCd =  this.getLoginRHQCd;
                });

            this.getCodeComboList1(this.getLoginRHQCd, "SUB_AUTH_ACCESS_CD")
                .then(data => {
                    this.rhqSubCdList = data;
                    this.selectRhqSubCd = this.getLoginCompanyCd;
                });
            let toDate = new Date();
            let fromDate = toDate.setMonth(toDate.getMonth() - 1);
            //this.FROM_DATE = DatePicker.create('from-picker-container', 'fromDate', 'icoFromDate', 'en', {} ,fromDate);
            //this.TO_DATE   = DatePicker.create('to-picker-container', 'toDate', 'icoToDate', 'en', {} ,new Date());
            this.rangePicker = DatePicker.createRangeWithOpener(
                            'from-picker-container', 'fromDate', 'icoFromDate',
                            'to-picker-container', 'toDate', 'icoToDate',
                            { type: 'date', locale: 'en', showToday: false },
                            (new moment()).add(-1, 'month').toDate(),
                            (new moment()).toDate()
            );
        });
    },
    beforeDestroy() {

    }
};
</script>

<style>
    /*  사용시 해당 컨포넌트에서만 사용 */
.zindex9999 { z-index: 99999999; }
.top20 {top: -20px;}
.float-none {float: none;}
.ftColor { color: dodgerblue!important; font-weight: bold!important; }
.sub_total {
  background: #f9f9f9 !important;
  font-weight: bold;
  width: 100% !important;
  height: 40px !important;
}
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/reprocessRatioList.vue